import moment from "moment";
import _ from "lodash";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { useLocation } from "react-router";
import dayjs from 'dayjs';
import { commonStrings,pdfStrings } from "../components/StringBundle";
import cclLogo from "../assets/images/logo_pdf.png";
import nclLogo from "../assets/images/ncl-logo.png";
import { roles } from "../constants/roles";
export const pageFilterKey = `FiltersTable.${window.location.pathname}`;
const productCodeLabels = commonStrings.productCodes;
const subtypeLabels = commonStrings.productSubtypeCodes;
const aromaLabels = commonStrings.aromaCodes;
const companyNameStrings = pdfStrings

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function openPdf(fileName, contentType, base64Data) {
  const dataUrl = `data:${contentType};base64,${base64Data}`;

  const newTab = window.open();
  if (newTab) {
    newTab.document.write(`
      <html>
        <head><title>${fileName}</title></head>
        <body style="margin:0">
          <iframe src="${dataUrl}" width="100%" height="100%" style="border:none;"></iframe>
        </body>
      </html>
    `);
    newTab.document.close();
  } else {
    alert('Please allow popups for this site.');
  }
}

// export excel pdf
export function exportExcelData(tableData, tableName){
   if (tableData && tableData.length > 0) {
        const ws = XLSX.utils.json_to_sheet(tableData);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, tableName + fileExtension);
      }
}

export const generateExcelData = (report_key_pair, report_details) => {
  const idSet = new Set(report_key_pair.map(k => k.id));
  const labelMap = Object.fromEntries(report_key_pair.map(({ id, label }) => [id, label]));

  return report_details.map((item) => {
    const row = {};
    for (const key in item) {
      if (idSet.has(key)) {
        row[labelMap[key]] = item[key];
      }
    }
    return row;
  });
};


export function mapDataToGridColumns(columns = [], data = []) {
  const validColumns = (columns || []).filter(({ dataIndex }) => dataIndex);

  const result = [];
  for (const i in data || []) {
    const row = data[i];
    const exportRow = {};
    for (const j in validColumns) {
      const { dataIndex, title } = validColumns[j];
      exportRow[title] = row?.[dataIndex];
    }
    result.push(exportRow);
  }

  return result;
}

export function insertIntoLabelMap(baseLabelMap = {}, extraFields = {}, insertPositions = []) {
  // Map final position → {dataIndex, title} for O(1) lookup during the single pass.
  const insertAt = new Map(
    insertPositions.map(({ key, position }) => [position, { dataIndex: key, title: extraFields[key] }])
  );

  const baseEntries = Object.entries(baseLabelMap);
  const totalLength = baseEntries.length + insertPositions.length;
  const result = [];
  let baseIdx = 0;

  for (let pos = 0; pos < totalLength; pos++) {
    if (insertAt.has(pos)) {
      result.push(insertAt.get(pos));
    } else {
      const [key, label] = baseEntries[baseIdx++];
      result.push({ dataIndex: key, title: label });
    }
  }

  return result;
}

export function removeKeysFromArray(dataArray, keysToRemove) {
  const keysToRemoveSet = new Set(keysToRemove);

  return dataArray.map(item => {
    const newItem = {};
    for (const key in item) {
      if (!keysToRemoveSet.has(key)) {
        newItem[key] = item[key];
      }
    }
    return newItem;
  });
}

export const allowedExtForAttachments = [
  "jpg",
  "jpeg",
  "png",
  "bmp",
  "webp",
  "pdf",
  "xlsx",
  "xls",
];

export function getDateFormat(date, format = ""){
  return moment(date, format);
}

export function isBeforeToday(date) {
  return dayjs(date).isBefore(dayjs().startOf("day"));
}

export function dateFormat(dt, format= '') {
  if(dt === null || dt === "") return;
  if(!_.isEmpty(format)){
    let dateStr = new Date(dt);
    const dt_format = moment(dateStr).format(format); 
    return dt === '' ? '' : dt_format;
  }else {
    if (dt === "0001-01-01T00:00:00Z" || !dt) {
      return "";
    }
    let dateVal = new Date(dt);
    return (
      dateVal.getDate() +
      "/" +
      (dateVal.getMonth() + 1) +
      "/" +
      dateVal.getFullYear()
    );
  }
}

export function dateTimeFormat(dateString, format = "YYYY-MM-DD hh:mm:ss A") {
  if (!dateString) return "";
  return moment.utc(dateString).format(format);
}

export function formatDateISO(dateStr, format) {
  if(!dateStr) return '';
  const fmt = format || 'DD-MM-YYYY';
  return moment.utc(dateStr, 'DD-MM-YYYY', true).local().format(fmt);
}

export function isDate(value) {
  return moment(value, moment.ISO_8601, true).isValid();
}

export function ConvertToISOWithOffset(inputDate, format){
  const isoWithOffset = moment(inputDate, format).format("YYYY-MM-DDTHH:mm:ssZ");
  return isoWithOffset;
}

export function dateFormatCheck(dt, format= ''){
  if(_.isEmpty(dt) || dt.startsWith('0001-01-0')){
    return null;
  }else {
    return dateFormat(dt, format);
  }
}

// add number of days on date
export function addDaysToDate(date, days, type = '') {
  if (!date) return null;
   if (type === 'moment') {
    return moment(date)?.add(days, 'days').toDate();
   }else {
   return date?.add(days, 'days').toDate();
   }
}

// sbtract number of days on date
export function subtractDaysToDate(date, days, type = '') {
  if (!date) return null;
   if (type === 'moment') {
    return moment(date)?.subtract(days, 'days').toDate();
   }else {
   return date?.subtract(days, 'days').toDate();
   }
}

export function convertToDateFormat(value) {
  return value ? dateFormat(value, 'DD-MM-YYYY') : '';
}

export function convertToFloat(value, decimal = 2) {
  const number = parseFloat(value);
  if (_.isNaN(number) || number === 0) {
    return 0.00;
  } else if (decimal === 0) {
    return number;
  }
  return Number(number.toFixed(decimal));
}

export function convertUnixToDate(unixTimestamp, format) {
  const formattedDate = moment.unix(unixTimestamp).format(format);
  return formattedDate
}

export function convertToInt(value) {
  return _.isNaN(parseInt(value)) ? 0 : parseInt(value);
}

export function convertToString(value) {
  return value ? value.toString() : '';
}
// convert date to TZ format
export function convertToTZFormat(date) {
    return moment(date).utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
}
export function formatISDDate(dt) {
  let dateStr = new Date(dt);
  const dt_format = moment.utc(dateStr).tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss A")//dateStr.getDate() + '-' + months[dateStr.getMonth() + 1] + '-' + dateStr.getFullYear();
  return dt === '' ? '' : dt_format;
}

export function formatISTDate(dt) {
  let dateStr = new Date(dt);
  const dt_format = moment.utc(dateStr).tz("Asia/Kolkata").format("DD-MM-YYYY HH:mm:ss A")
  return dt === '' ? '' : dt_format;
}
export function defaultauditpayload(id,user,modifiedby="") {

  let auditPayload1 = [
    {
      "parentId":id,
      "field":"Modified By",
      "newValue":  user,
      "oldValue":modifiedby,
      "createdBy":user,
    }
  ];
  return auditPayload1;
}

export function auditparams(params, id, user, modifiedby = "") {
  if (params.length > 0) {
    return params;
  } else {
    return defaultauditpayload(id, user, modifiedby);
  }
}

export function formatExcelDateNew(dt) {
    let dateStr = new Date(dt);
    const dt_format = moment(dateStr).format('YYYY-MM-DD'); //dateStr.getDate() + '-' + months[dateStr.getMonth() + 1] + '-' + dateStr.getFullYear();
    return dt === '' ? '' : dt_format + "T06:31:56Z";
  }
export function formatDate1  (datestr)  {
  let dateVal = new Date(datestr);
  return datestr
    ? dateVal.getDate() +
        "-" + 
        (dateVal.getMonth() + 1) +
        "-" +
        dateVal.getFullYear()
    : "";
};

export function numberWithCommas(n) {
  var parts = n?.toString()?.split(".");
  return parts
    ? parts?.[0]?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (parts[1] ? "." + parts[1] : "")
    : "";
}
// have 2 functions, formatNumber and within that if type is decimal, then call convertNumberToDecimal.
// Within formatNumber, check if the value is number or not. and based on that progress to decimal conversion
export function formatNumber(value, decimal){
  return numberWithCommas(Number(value)?.toLocaleString('en-IN', { minimumFractionDigits: decimal }));
}
export function onKeyPressNumber(event) {
  if (!(/^[0-9]+$/.test(event.key))) {
    event.preventDefault();
  }
}
export function restrictkeyupdown (e){
  if(['ArrowDown', 'ArrowUp']?.includes(e.key)){
    e.preventDefault();
  }
}
 export function formatDatenew  (datestr)  {
  let dateVal = datestr ? new Date(datestr) : new Date();
  return (
    dateVal.getDate() +
    "/" +
    (dateVal.getMonth() + 1) +
    "/" +
    dateVal.getFullYear()
  );
}

export const inventorycolumns = [
  { id: "item_name", label: "Item" },
  { id: "total_po_quantity", label: " Total PO Quantity " },
  { id: "in_transit_quantity", label: " Pending PO Quantity " },
  // { id: "in_transit_average_price", label: "Avg $" },
  { id: "stock_available_quantity", label: "Received Quantity" },
  { id: "item_quantity_on_hand", label: "Quantity On Hand" },
  // { id: "item_quantity_on_order", label: "Quantity On Order" },
  { id: "item_quantity_committed", label: "Quantity Committed" },
  { id: "item_quantity_back_ordered", label: "Back Order Quantity" },
  { id: "allocated_quantity_ccl_quote", label: "Open Quote Allocated Quantity" },
  { id: "allocated_quantity_other_quote", label: "Other Quotes Allocated Quantity" },
  { id: "average_price", label: "Average Cost" },
  { id: "show_locations", label: "Locations" },
];

export const inventorycolumnslocation = [
  { id: "locationName", label: "Location Name" },
  { id: "totalQuantityOnHand", label: "Total Quantity On Hand" },
  // { id: "totalQuantityOnOrder", label: "Total Quantity On Order" },
  { id: "totalQuantityCommitted", label: "Total Quantity Committed" },
  { id: "totalQuantityBackOrdered", label: "Total Quantity Back Order" },
  // { id: "totalQuantityAvailable", label: "Total Quantity Available" },
  { id: "averagePrice", label: "Average Cost" },
  { id: "sublocationName", label: "Sub Location Name" },
  { id: "quantityOnHand", label: "Total Quantity On Hand" },
  // { id: "quantityOnOrder", label: "Total Quantity On Order" },
  { id: "quantityCommitted", label: "Total Quantity Committed" },
  { id: "quantityBackOrdered", label: "Total Quantity Back Order" },
  // { id: "quantityAvailable", label: "Quantity Available" },
  { id: "averagePriceSub", label: "Average Cost" },
];

export function commify(n) {
  var parts = n.toString().split(".");
  const numberPart = parts[0];
  const decimalPart = parts[1];
  const thousands = /\B(?=(\d{3})+(?!\d))/g;
  return (
    numberPart.replace(thousands, ",") + (decimalPart ? "." + decimalPart : "")
  );
}

export function removeComma(val) {
  var a = val;
  if (val?.toString().indexOf(",") > -1) {
    // eslint-disable-next-line
    a = a?.replace(/\,/g, "");
    return Number(a);
  } else {
    return val;
  }
}

export function formatDate(datestr) {
  return datestr ? new Date(datestr).toLocaleString("en-IN") : "";
}

export function companyFormatValues(input) {
  const valuesArray = input.split(',').map(item => item.trim());
  const formattedArray = valuesArray.map(value => ({
      label: value,
      value: value
  }));
  return formattedArray;
}


export const exportToExcel = (data, filename) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const ws = XLSX.utils.json_to_sheet(data);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blobData = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(blobData, filename + fileExtension);
};

// Formats an array of objects into a label-value pair array for dropdowns
export const formatToSelection = (data = [], key, valuekey) => {
  const valueprop = valuekey || key; 
    return data?.map(v => ({ label: v[key], value: String(v[valueprop]) })) || [];
};

// Function to format date
export function formatDateSafe(date, dateformat = "DD-MM-YYYY") {
  if (!date) return ''; // Return empty string if null/undefined/empty
  const formattedDate = dayjs(date);
  const safeFormat = typeof dateformat === "string" ? dateformat : "DD-MM-YYYY";
  return formattedDate.isValid() ? formattedDate.format(safeFormat) : null;
}

export function convertDayJsToRawFormat(date, dateformat = "DD-MM-YYYY") {
  if (!date) return ''; // Return empty string if null/undefined/empty
  const formattedDate = dayjs(date,dateformat);
  return formattedDate;
}

// Return a dayjs object from any value — passthrough if already dayjs, otherwise parse with format
export function toDayjs(date, dateformat = "DD-MM-YYYY") {
  if (!date) return null;
  if (dayjs.isDayjs(date)) return date;
  if (date instanceof Date) return dayjs(date);
  return convertDayJsToRawFormat(date, dateformat);
}


// Function to convert snake_case to Title Case
export function snakeToTitleCase(snakeStr) {
  return snakeStr
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

// Transform object keys from snake_case to Title Case
export function transformKeysToTitleCase(obj) {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [snakeToTitleCase(key), value])
  );
}

// Function to fetch filtered quarter list based on the financial year
export async function fetchFilteredQuarterList(financialYear, getQuaterList) {
  const res = await getQuaterList();
  if (!res) return [];

  const [startYearStr, endYearStr] = financialYear.split("-");
  const startYear = parseInt(startYearStr);
  const endYear = parseInt(endYearStr);

  const quarterMonthsMap = {
    Q1: { start: 4, end: 6, year: startYear },
    Q2: { start: 7, end: 9, year: startYear },
    Q3: { start: 10, end: 12, year: startYear },
    Q4: { start: 1, end: 3, year: endYear },
  };

  const filteredQuarters = res.filter((quarter) => {
    const qName = quarter.channel_name;
    const qMonths = quarterMonthsMap[qName];
    if (!qMonths) return false;

    const quarterEndDate = moment({ year: qMonths.year, month: qMonths.end - 1 }).endOf("month");
    return quarterEndDate.isSameOrAfter(moment(), "day");
  });

  return filteredQuarters;
}

// captialize string
export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

// Function to build cost label
export function buildCostLabel(baseLabel, categoryType) {
    const unit = categoryType === commonStrings.domestic ? commonStrings.INRPerKg : commonStrings.USDPerKg;
    return `${baseLabel} ${unit}`;
}

export function factoryCodes(codes){
  const arr = [];
  for (const key in codes) {
    arr.push({ label: codes[key], value: codes[key] });
  }
  return arr;
}

export const productCodes = [
  { label: productCodeLabels?.sprayDredCoffee, value: "SD" },
  { label: productCodeLabels?.freezeDrried, value: "FD" },
  { label: productCodeLabels?.agglomaratedCoffee, value: "AG" },
  { label: productCodeLabels?.coffeeOil, value: "CO" },
  { label: productCodeLabels?.roastedCoffee, value: "RC" },
  { label: productCodeLabels?.concentratedLiquid, value: "LC" },
  { label: productCodeLabels?.RoastednGroundCoffee, value: "RG" },
  { label: productCodeLabels?.instantCoffeePremix, value: "PC" },
  { label: productCodeLabels?.teaPremix, value: "PT" },
  { label: productCodeLabels?.sdChicoryCoffee, value: "SDCM" },
  { label: productCodeLabels?.fdChicoryCoffee, value: "FDCM" },
  { label: productCodeLabels?.agglomaratedChicoryCoffee, value: "AGCM" }
];

export const productSubtypeCodes = [
  { label: subtypeLabels?.notApplicable, value: "NA" },
  { label:subtypeLabels?.flaoured, value: "FL" },
  { label: subtypeLabels?.coldBrew, value: "CB" },
  { label: subtypeLabels?.ies, value: "IE" },
  { label: subtypeLabels?.microground, value: "MG" },
  { label: subtypeLabels?.dryBlend, value: "CA" },
  { label: subtypeLabels?.semiFinished, value: "SF" },
];

export const aromaCodes = [
  { label: aromaLabels?.ies, value: "IES" },
  { label: aromaLabels?.withoutAroma, value: "WA" },
  { label: aromaLabels?.ssc, value: "SCC" },
];

export const marketOptions = [{ market: "Export" }, { market: "Domestic" }];


 // For iterate the id and labels of the table and dropdown fields
export const createColumnsFromBundle = (fields = {}, type) => {
  const result = [];

  for (const key in fields) {
    if (type === 'dropdownpairs') {
      result.push({
        label: fields[key],
        value: key,
      });
    } else {
      result.push({
        label: fields[key],
        id: key,
      });
    }
  }
  return result;
};

// to normalize form data before sending to backend
export const normalizeFormData = (data) => {
  const transformed = {};
  for (const key in data) {
    const value = data[key];
    transformed[key] =
      value && typeof value === "object" && ("value" in value ||  "label" in value)
        ? value.value || value.label
        : value;
  }
  return transformed;
};

export const company_name_list = [
  { value: "All", label: commonStrings.all },
  { value: "CCL", label: commonStrings.ccl },
  { value: "NCL", label: commonStrings.ncl },
];

//  Roles that are restricted to viewing CCL company records only.
//  Users with these roles cannot switch to NCL or All Records.

export const COMPANY_RESTRICTED_ROLES = [
  "Production Assistant",
  "Production Planning",
  "Production Manager",
  "Quality Manager",
  "Analyst QA",
  "Manager GC Stores",
  "GC Stores Executive",
  "Auditor",
  "Vendor",
  "Read Only",
  "View Only",
];

export function isCompanyRestrictedRole(role) {
  return COMPANY_RESTRICTED_ROLES.includes(role);
}

export function getFilteredFactoryList(factoryList, role) {
  if (!Array.isArray(factoryList)) return factoryList;
  if (isCompanyRestrictedRole(role)) {
    return factoryList.filter(item => item.lov_name?.toLowerCase() !== "vietnam");
  }
  return factoryList;
}

export function getFilteredEntityList(entityList, role) {
  if (!Array.isArray(entityList)) return entityList;
  if (isCompanyRestrictedRole(role)) {
    return entityList?.filter(item => item.entity_name !== "NCCL");
  }
  return entityList;
}

export function getCompanyFilterList(role) {
  if (isCompanyRestrictedRole(role)) {
    return company_name_list.filter(item => item.value === "CCL");
  }
  return company_name_list;
}

export function getDefaultCompany(role, sessionKey, fallback = "All") {
  if (isCompanyRestrictedRole(role)) return "CCL";
  return sessionStorage.getItem(sessionKey) || fallback;
}


export const CCL_DEFAULT_ROLES = [
  roles.managerPurchaseGC,
  roles.purchaseExecutiveGC,
  roles.purchaseExecutiveGCview,
];

export function isCclDefaultRole(role) {
  return CCL_DEFAULT_ROLES.includes(role);
}

//  Use only in the modules above; other modules should keep using getDefaultCompany.
export function getDefaultCompanyForPurchaseGC(role, sessionKey, fallback = "All") {
  if (isCclDefaultRole(role)) return sessionStorage.getItem(sessionKey) || "CCL";
  return getDefaultCompany(role, sessionKey, fallback);
}


export const getCompanyConfig = (companyName) => {
  const config = {
    CCL: {
      logo: cclLogo,
      name: companyNameStrings.companyName,
      address : "CCL Products (India) Ltd, 8-2-269/4A, Road No.2, Banjara Hills, Hyderabad - 500034, Telangana, India."
    },
    NCL: {
      logo: nclLogo,
      name: companyNameStrings.nclCompany,
      address: "Ngon Coffee Company Limited Cu Kuin Industrial Complex, Dray Bhang Commune Dak Lak Province, Vietnam"
    },
  };

  const defaultConfig = config.CCL;
  return config[companyName] || {
    ...defaultConfig,
    name: companyName || defaultConfig.name,
  };
};

export function getCleanPayload(payload){
  const cleanPayload = {};
        for (const key in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          const value = payload[key];
          if (value !== undefined && value !== null && !Number.isNaN(value)) {
            cleanPayload[key] = value;
          }
        }
      }
      return cleanPayload;
}

// formatNumber
export const formatNumberWithCommas = (
  value,
  { fractionDigits = 0, currency = null } = {}
) => {
  if (value == null || value === "") return "";

  const options = {
    minimumFractionDigits: fractionDigits,
  };

  if (currency) {
    options.style = "currency";
    options.currency = currency;
  }

  return Number(value).toLocaleString("en-IN", options);
};

//for add multiple vehicle => vehicle number validation
// Cleans and formats the vehicle number
// - Removes special characters and spaces
// - Converts to uppercase
// - Limits length to 11 characters
export const normalizeVehicle = (value = "") =>
  value
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .toUpperCase()               
    .slice(0, 13);



// Full vehicle number pattern (Indian format)
// Example: KA01AB1234, MH12C9999


// Final validation (used on blur or submit)
// Returns true if vehicle number is valid
export const isVehicleFullValid = (vehicleNo = "") => {
  if (!vehicleNo) return false;
  return /^([A-Z]{3} ?\d{4}|[A-Z]{2} ?\d{1,2}( ?[A-Z]{1,2})? ?\d{4})$/.test(vehicleNo);
};


// open document from base64
export function openBase64File(base64Data, fileName, mimeType = "application/pdf") {
  // decode base64 string to binary
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // create blob
  const blob = new Blob([byteArray], { type: mimeType });

  // create blob url
  const blobUrl = URL.createObjectURL(blob);

  // open in new tab
  window.open(blobUrl, "_blank");
}

export async function fileToBase64WithoutMime(file) {
  const reader = new FileReader();
  const dataUrl = await new Promise((resolve, reject) => {
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

  const str = dataUrl?.toString?.() || "";
  return str.replace(/^data:application\/[a-zA-Z0-9.+-]+;base64,/, "");
}


export function getDateMinusMonths(months = 1) {
  return moment().subtract(months, "months").toDate();
}
export function viewDataStructure(dataList = []) {
  let viewData = [];
  dataList.map((item) => {
    viewData.push(
      {
        type: "label",
        value: item.label,
        bold: true,
        sm: item?.sm || item?.labelSm || "3",
      },
      {
        type: item?.type === "checkbox" ? "checkbox" : "label",
        checked: Boolean(item.value),
        disabled: item?.type === "checkbox" ? true : false,
        value: item.value || "-",
        sm: item?.sm || item?.valueSm || "3",
      }
    );
  });
  return viewData;
}

// Array of objects with {label, value}
export const mapObjectToArray = (
  source = {}, //columns
  values = {}, //rows value
  labelKey = "label", // labelkey anme
  valueKey = "value", //value keyname
  defaultLabelSm = "3",
  defaultValueSm = "3",
  overrideKeys = {}, //{ packing_name: {labelSm:3, valueSm:9}}
) => {
  const result = [];
  for (const id in source) {
    if (source.hasOwnProperty(id)) {
      const override = overrideKeys[id] || {};
      result.push({
        [labelKey]: source[id],
        [valueKey]: _.isEmpty(values) ? id : values?.[id],
        labelSm: override.labelSm || defaultLabelSm,
        valueSm: override.valueSm || defaultValueSm,
      });
    }
  }
  return  result;
};

// Production Line
export const PRODUCTION_LINE_MAP = {
  duggirala: {
    SD: ["SD1", "SD2"],
    SDCM: ["SD1", "SD2"],
    AG: ["SD1", "SD2"],
    AGCM: ["SD1", "SD2"],
    CO: ["SD1", "SD2"],
    LC: ["SD1", "SD2"],
    FD: ["FD1"],
    FDCM: ["FD1"],
    PC: ["PC"],
    PT: ["PC"],
    RC: ["RCB"],
    RG: ["RG"],
  },
  "f&b": {
    SD: ["SD1"],
    SDCM: ["SD1"],
    AG: ["SD1"],
    AGCM: ["SD1"],
  },
  sez: {
    FD: ["FD1"],
    FDCM: ["FD1"],
  },
  vietnam: {
    SD: ["SD1", "SD2"],
    SDCM: ["SD1", "SD2"],
    AG: ["SD1", "SD2"],
    AGCM: ["SD1", "SD2"],
    CO: ["SD1", "SD2"],
    LC: ["SD1", "SD2"],
    FD: ["FD1"],
    FDCM: ["FD1"],
  },
  switzerland: {
    
  }
};

export function getProductionLines(factory_code, product_code) {
  if (!factory_code || !product_code) return [];
  const factoryMap = PRODUCTION_LINE_MAP[factory_code.toLowerCase()];
  if (!factoryMap) return [];
  return factoryMap[product_code?.toUpperCase()] || [];
}

export const getDestinationPortsByCompany = (ports = [], companyName) => {
  const isNCL = companyName === "NCL";
  return ports?.filter((port) =>
    isNCL ? port?.destination_id == 3 : port?.destination_id !== 3,
  );
};